import React, {useState} from "react";
import {useMutation} from "@apollo/client";
import {Button, Col, Container, Row} from "react-bootstrap";
import FlashMessage from "../../shared/FlashMessage";
import {saveData} from "../../../helpers/Api";
import {getClientsQuery, InviteClientMutation} from "./ClientQueries";
import {BackButton} from "../../../helpers/ButtonHelper";
import PageTitle from "../../../layout/PageTitle";
import {useNavigate} from "react-router-dom";

const InviteClientForm = () => {
  const [flash, setFlash] = useState({});
  const navigate = useNavigate()
  const client = {fName: '', lName: '', email: '', phone: ''}
  const [saveCall] = useMutation(InviteClientMutation, {refetchQueries: [getClientsQuery]})

  const onSubmit = (event) => {
    event.preventDefault()
    saveData({
      event: event,
      gqlCall: saveCall,
      query_key: 'inviteClient',
      flash_callback: setFlash,
      success: (res) => {
        navigate(`/clients/${res.client.id}`)
      }
    })
  }

  return (
    <>
      <Container>
        <PageTitle title="Invita un client"/>
        <div className='d-sm-flex align-items-center mb-4 mt-4'>
          <Col sm={7} className='flex-grow-1'>
            <form onSubmit={onSubmit}>
              <Row className="mb-2">
                <Col md={6}>
                  <label htmlFor="fName">Prenume</label>
                  <input type='text' name='fName' className="form-control" id="fName" defaultValue={client.fName}/>
                </Col>
                <Col md={6}>
                  <label htmlFor="lName">Nume</label>
                  <input type="text" name='lName' className="form-control" id="lName" defaultValue={client.lName}/>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={6}>
                  <label htmlFor="phone">Telefon</label>
                  <input type="text" name='phone' className="form-control" id="phone" defaultValue={client.phone}/>
                </Col>
                <Col md={6}>
                  <label htmlFor="email">Email</label>
                  <input type="email" name="email" className="form-control" id="email" defaultValue={client.email}/>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={12}>
                  <label htmlFor="email">Parola</label>
                  <input type="text" name="password" className="form-control" id="email" defaultValue="12345asdf"
                         readOnly={true} disabled={true}/>
                </Col>
              </Row>
              <Row className="mb-3">
                <FlashMessage flash={flash} buttons={
                  <>
                    <BackButton to='/clients' className='float-end' showText={true} size='md'/>
                    <Button type='submit' className='float-end'>Invita</Button>
                  </>
                }/>
              </Row>
            </form>
          </Col>
        </div>
      </Container>
    </>
  )
};

export default InviteClientForm;